import React from 'react';

import type { Control } from 'react-hook-form';

import TextFieldComp from '@/components/TextFieldComp';
import TimeFieldComp from '@/components/TimeFieldComp';
import { MeasureDateTime } from '@/domain/defecation/service/entity/valueObjects/measureDateTime';
import { Milk } from '@/domain/milk/service/entity/valueObjects/milk';

/**
 * ミルク入力タイプ
 */
export type MilkInputType = {
  /** ミルク */
  milk: number,
  /** 測定日時 */
  measureDateTime: string,
}

/**
 * 入力フォーム
 */
export type MilkFormInputType = {
  /** コントローラー */
  control: Control<MilkInputType, never>,
  /** エラー */
  errors: any,
}

const MilkFormInput: React.FC<MilkFormInputType> = ({
  control,
  errors,
}) => (
  <div>
    <TextFieldComp
      type={Milk.type}
      control={control}
      rules={Milk.validationRule}
      name={Milk.key}
      label={Milk.label}
      placeholder={Milk.placeholder}
      errors={errors}
    />
    <TimeFieldComp
      control={control}
      name={MeasureDateTime.key}
      label={MeasureDateTime.label}
      rules={MeasureDateTime.validationRule}
      errors={errors}
    />
  </div>
);

export default MilkFormInput;
